import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';

export const titleCss = css(typography.effra18, {
  width: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: colorsPalette.transparent,
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  textAlign: 'left',
  border: 0,
  padding: '32px 18px 32px 0',
  [MediaQueries.mdAndUp]: {
    padding: '32px 0',
  },
});

export const titleLabelCss = css({
  paddingRight: 10,
});

export const chevronCss = css({
  fontSize: 8,
  [MediaQueries.mdAndUp]: {
    fontSize: 10,
  },
});

export const chevronRotatedCss = css({
  transform: 'rotate(180deg)',
});

export const richTextCss = css(
  {
    color: colorsPalette.grey60,
    paddingTop: 5,
    paddingBottom: 20,
    [MediaQueries.mdAndUp]: {
      paddingTop: 0,
      paddingBottom: 40,
    },
  },
  typography.effra18,
);

export const contentCss = css({
  borderBottom: `1px solid ${colorsPalette.brown40}`,
  width: '100%',
  ['a']: {
    color: colorsPalette.red,
  },
});
